<div class="d-flex justify-content-end flex-auto">
  <div class="bulk-upload-influencer-container">
    <div class="bulk-upload-influencer-title">{{'bulk_upload_influencer.title' | translate}}</div>
    <div class="bulk-upload-influencer-description">{{'bulk_upload_influencer.description' | translate}}</div>
    <button class="button sm-button blue bulk-upload-influencer-btn"
            [disabled]="hasSelectedInfluencers"
            (click)="showBulkUploadInfluencerModal()">
      {{'bulk_upload_influencer.btn_label' | translate}}
    </button>
  </div>
</div>
<achoo-popup #BulkUploadInfluencerPopup [isSpecialPopup]="true"
             (cancelCallback)="closeBulkUploadInfluencerModal()">
  <bulk-upload-influencer-modal #BulkUploadInfluencerModalComponent
                                [influencerGroup]="influencerGroup"
                                [bulkUploadInfluencer]="bulkUploadInfluencer"
                                (beforeUploadBulkInfluencerEvent)="beforeUploadBulkInfluencer()">
  </bulk-upload-influencer-modal>
</achoo-popup>
<achoo-popup #bulkUploadNotificationPopup
             [isNotification]="true"
             modelTitle="{{modelTitle}}">
  <span>{{popupMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer.component.html